import { CONSTANTS } from "../../data";
import type { GameState } from "../../types";

export const sessionReducer = (state: GameState, action: any): GameState => {
  switch (action.type) {
    case "START_SESSION":
      return {
        ...state,
        sessionMode: {
          ...action.mode,
          startTime: Date.now(),
        },
        screen: "game",
      };

    case "START_RUSH_MODE": {
      const allRecipes = Object.keys(CONSTANTS.RECIPES);
      const rushInventory = {};
      
      // Add all ingredients and tools
      Object.entries(CONSTANTS.ITEMS).forEach(([id, item]) => {
        if (item.type === 'ingredient' || item.type === 'tool') {
          rushInventory[id] = item.consumable ? 99 : 1;
        }
      });
    
      return {
        ...state,
        screen: "game",
        sessionMode: {
          type: "rush",
          startTime: Date.now(),
          score: 0,
          served: 0,
          tips: 0,
          combosDiscovered: 0,
        },
        rushModeState: {
          originalInventory: state.inventory,
          originalDiscoveredRecipes: state.discoveredRecipes,
        },
        inventory: rushInventory,
        discoveredRecipes: allRecipes,
        customers: [], // Start with a clean queue
      };
    }

    case "UPDATE_SESSION_MODE":
      return {
        ...state,
        sessionMode: {
          ...state.sessionMode,
          ...action.updates,
        },
      };

    case "END_SESSION": {
      const isRush = state.sessionMode.type === 'rush';
      const inventory = isRush ? state.rushModeState.originalInventory : state.inventory;
      const discoveredRecipes = isRush ? state.rushModeState.originalDiscoveredRecipes : state.discoveredRecipes;
    
      return {
        ...state,
        screen: "results",
        lastRushScore: action.score || state.lastRushScore,
        inventory: inventory || { ...CONSTANTS.STARTING_INVENTORY },
        discoveredRecipes: discoveredRecipes || [],
        rushModeState: { originalInventory: null, originalDiscoveredRecipes: null },
        sessionMode: { ...CONSTANTS.DEFAULT_SESSION_MODE },
        customers: [], // Clear customers after a session
      };
    }

    case "SET_ACTIVE_SEASON":
      return { ...state, activeSeason: action.season };

    case "SET_TRENDING_DRINK":
      return { ...state, trendingDrink: action.drink };

    default:
      return state;
  }
};
